<template>
  <div class="index">
    <div class="index_head">
      <div class="index_head_text">地中海<br />航海家俱乐部</div>
      <div class="index_head_text_1">会员申请（匹配）表</div>
    </div>
    <div class="index_main">
      <div class="index_main_top">
        加入地中海航海家俱乐部，尊享各种船上特权和礼遇，让您的航程更精彩！地中海航海家俱乐部特设4种专属等级，经典卡、银卡、金卡、钻石卡。<span
          @click="interestClick"
          >查看会员权益。</span
        >
        <br />如您拥有其他旅游品牌、航空公司、邮轮公司或国际连锁酒店的会员卡，在我们认可范围内，我们也可以为之匹配相应的地中海航海家俱乐部会员等级以及会员权益！
      </div>
      <div class="index_main_form">
        <div class="index_main_icon icon_left"></div>
        <div class="index_main_icon icon_right"></div>
        <div class="index_main_form_top">
          <div class="index_main_form_title">
            <span>个人信息</span>
            <span class="index_main_form_title_tip">姓名请用拼音填写</span>
          </div>
          <div class="index_main_form_tip">*必填项</div>
        </div>
        <div class="main_form_input">
          <van-field
            v-model="form.surname"
            label="姓*"
            placeholder="请用拼音填写"
          />
          <van-field
            v-model="form.name"
            label="名*"
            placeholder="请用拼音填写"
          />
          <van-field label="性别*" class="radio_input">
            <template #input>
              <van-radio-group v-model="form.sex" direction="horizontal">
                <van-radio name="M" shape="square" checked-color="#152342"
                  >男</van-radio
                >
                <van-radio name="D" shape="square" checked-color="#152342"
                  >女</van-radio
                >
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            class="date_input"
            :value="form.birthday"
            label="出生日期（日/月/年）*"
            placeholder="日/月/年"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              show-toolbar
              type="date"
              :min-date="minDate"
              :max-date="maxDate"
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
          <!-- <van-field  v-model="form.address"  class="widt68_input" label="地址*"  placeholder="地址" />
          <van-field  readonly  clickable class="widt68_input"  :value="form.area"  label="省/市*"  placeholder="省/市"  @click="showArea = true"/>
          <van-popup v-model="showArea" position="bottom">
            <van-area  :area-list="areaList"  @confirm="onConfirmArea" :columns-num="2"  @cancel="showArea = false"/>
          </van-popup> -->
          <van-field
            v-model="form.email"
            class="widt74_input"
            label="E-MAIL*"
            placeholder="E-MAIL"
          />
          <van-field
            v-model="form.mobile"
            class="widt74_input"
            label="电话号码*"
            placeholder="电话号码"
          />
          <div class="input_button">
            <van-field
              v-model="form.code"
              class="widt74_input"
              label="验证码*"
              placeholder="验证码"
            />
            <van-button
              class="btn"
              round
              type="info"
              size="small"
              @click="onCode"
              >{{ buttonText }}</van-button
            >
          </div>
        </div>
        <div class="input_line"></div>
        <div class="input_text_box">
          <van-checkbox
            v-model="checkedAll"
            icon-size="18px"
            checked-color="#152342"
            class="input_checkbox"
            @click="checkedAllClick"
            >一键全选</van-checkbox
          >
          <van-checkbox
            v-model="checked1"
            icon-size="18px"
            checked-color="#152342"
            class="input_checkbox"
            @click="checkedClick(1)"
            >*我已阅读并同意以下条款：</van-checkbox
          >
          <div class="input_text">
            • 阅读并接受
            <a href="javascript:;" @click="yinshi">个人信息保护政策</a> 以及
            <a href="javascript:;" @click="tiaokuan">会员条款</a>。
          </div>
          <div class="input_text">• 会员匹配仅限本人实名匹配一次</div>
          <div class="input_text">• 会员匹配不接受18周岁以下宾客的申请</div>
          <div class="input_text">
            • 会员匹配不可将地中海航海家俱乐部积分与其他公司会员积分合并累计
          </div>
          <div class="input_text">
            •
            MSC地中海邮轮有权拒绝任何会员匹配需求，也可随时终止此活动，而无需根据任何法规要求，也无需承担或任何法律后果
          </div>
          <van-checkbox
            v-model="checked2"
            icon-size="18px"
            checked-color="#152342"
            class="input_checkbox flex-start"
            @click="checkedClick(2)"
            >*为使我加入会员计划并在全球范围内享受会员权益，我同意将我的个人信息传输至位于瑞士的MSC
            Cruises SA</van-checkbox
          >
          <div class="input_text">“本公司”：地中海邮轮船务（上海）有限公司</div>
          <div class="input_text">
            “MSC地中海邮轮”或“我们”：地中海邮轮船务（上海）有限公司及其关联公司，关联公司包括但不限于本公司位于瑞士的母公司及邮轮产品的承运人MSC
            Cruises SA
          </div>
          <div class="input_text text">
            了解更多地中海航海家俱乐部信息，请参阅地中海邮轮<a
              @click="mscPC"
              href="https://www.msccruises.com.cn/"
              >中国官网</a
            >
          </div>
        </div>
        <div class="input_line"></div>
        <div class="input_other">
          <van-checkbox
            v-model="other_checked"
            icon-size="18px"
            checked-color="#152342"
            class="input_checkbox"
            >我需要进行会员匹配（若不需要请直接提交）</van-checkbox
          >
          <div v-if="other_checked">
            <van-field
              v-model="form.other_member_name"
              class="widt100_input"
              :label="other_checked ? '会员卡名称*' : '会员卡名称'"
              placeholder="会员卡名称"
            />
            <van-field
              v-model="form.other_member_level"
              class="widt74_input"
              :label="other_checked ? '会员级别*' : '会员级别'"
              placeholder="会员级别"
            />
            <!-- <div class="input_other_text">如您是美国运通卡匹配用户，请在“会员级别”处填写：<b>运通卡号前8位+空格+卡号后5位</b></div> -->
            <div class="input_other_btn" @click="uploadClick">
              点击上传<span>匹配会员信息</span>图片
            </div>
            <div class="input_other_imgs">
              <div class="van-uploader" v-if="form.member_image_zheng">
                <div class="van-uploader__wrapper">
                  <div class="van-uploader__preview">
                    <div class="van-image van-uploader__preview-image">
                      <img
                        class="van-image__img"
                        style="object-fit: cover;"
                        :src="form.member_image_zheng"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="van-uploader" v-if="form.member_image_fan">
                <div class="van-uploader__wrapper">
                  <div class="van-uploader__preview">
                    <div class="van-image van-uploader__preview-image">
                      <img
                        class="van-image__img"
                        style="object-fit: cover;"
                        :src="form.member_image_fan"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index_foot">
      <div class="index_foot_bg">
        <div class="btn submit" @click="onSubmit">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import area from "@/util/area";
import {
  dateFormat,
  getSession,
  setSession,
  chineseToPinYin
} from "@/util/util";
import { ossBaseUrl } from "@/config/env.js";
import Ajax from "@/util/ajax";
export default {
  name: "index",
  data() {
    return {
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      showPicker: false,
      form: {
        surname: "",
        name: "",
        sex: "",
        birthday: "",
        date: "",
        mobile: "",
        address: "China",
        email: "",
        province: "China",
        city: "China",
        area: "China",
        code: "",
        other_member_name: "",
        other_member_level: "",
        member_image_zheng: "",
        member_image_fan: "",
        channel: 1
      },
      checkedAll: false,
      checked1: false,
      checked2: false,
      other_checked: false,
      showArea: false,
      areaList: {},
      buttonText: "获取验证码",
      times: "",
      codeBool: true,
      areas: []
    };
  },
  created() {
    this.areaList = area;
    let form = getSession("form");
    if (form) {
      this.form = form;
      if (form.date) {
        this.currentDate = new Date(form.date);
      }
    }
    let img1 = getSession("url1");
    let img2 = getSession("url2");
    // Toast(img1);
    // Toast(img2);

    if (img1) {
      this.form.member_image_zheng = img1;
    } else {
      this.form.member_image_zheng = "";
    }
    if (img2) {
      this.form.member_image_fan = img2;
    } else {
      this.form.member_image_fan = "";
    }
    let other_checked = getSession("other_checked");
    if (other_checked) {
      this.other_checked = other_checked;
    }
    let checkedAll = getSession("checkedAll");
    if (checkedAll) {
      this.checkedAll = checkedAll;
    }
    let checked1 = getSession("checked1");
    if (checked1) {
      this.checked1 = checked1;
    }
    let checked2 = getSession("checked2");
    if (checked2) {
      this.checked2 = checked2;
    }
    let areas = getSession("areas");
    if (areas) {
      this.areas = areas;
    }
  },
  mounted() {},
  methods: {
    onConfirm(time) {
      this.form.birthday = dateFormat(time, "dd-MM-yyyy");
      this.form.date = dateFormat(time, "yyyy/MM/dd");
      this.showPicker = false;
    },
    onConfirmArea(values) {
      this.areas = values;
      this.form.area = values.map(item => item.name).join("/");
      this.showArea = false;
    },
    onSubmit() {
      const {
        surname,
        name,
        sex,
        birthday,
        address,
        area,
        email,
        mobile,
        province,
        city,
        code,
        other_member_name,
        other_member_level,
        member_image_zheng,
        member_image_fan
      } = this.form;
      let areas = this.areas;
      let checkedAll = this.checkedAll;
      let other_checked = this.other_checked;
      let namePattern = /[^A-Za-z\s]/g;
      if (!surname) {
        Toast("请输入姓");
        return;
      }
      if (namePattern.test(surname)) {
        Toast("请输入正确格式的姓");
        return;
      }
      if (!name) {
        Toast("请输入名");
        return;
      }
      if (namePattern.test(name)) {
        Toast("请输入正确格式的名");
        return;
      }
      if (!sex) {
        Toast("请选择性别");
        return;
      }
      if (!birthday) {
        Toast("请选择出生日期");
        return;
      }
      if (!address) {
        Toast("请输入地址");
        return;
      }
      if (!area) {
        Toast("请选择省/市");
        return;
      }
      let emailMyreg = /^[\.a-zA-Z0-9_-]+@[\.a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!email) {
        Toast("请输入E-mail");
        return;
      }
      if (!emailMyreg.test(email)) {
        Toast("请输入正确E-mail");
        return;
      }
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!mobile) {
        Toast("请输入手机号");
        return;
      }
      if (!myreg.test(mobile)) {
        Toast("请输入正确手机号");
        return;
      }
      if (!code) {
        Toast("请输入验证码");
        return;
      }
      if (other_checked) {
        if (!other_member_name) {
          Toast("请输入会员卡名称");
          return;
        }
        if (!other_member_level) {
          Toast("请输入会员级别");
          return;
        }
        if (!member_image_zheng && !member_image_fan) {
          Toast("最少上传一张图片");
          return;
        }
      }
      if (!checkedAll) {
        Toast("请同意并勾选条款");
        return;
      }
      let data = {};
      let newForm = JSON.parse(JSON.stringify(this.form));
      for (let key in newForm) {
        if (key === "area") {
          // data.province = areas[0].name;
          // data.city = areas[1].name;
          // data.en_province = chineseToPinYin(data.province);
          // data.en_city = chineseToPinYin(data.city);
          data.province = "China";
          data.city = "China";
          data.en_province = "China";
          data.en_city = "China";
        } else if (
          key === "other_member_name" ||
          key === "other_member_level" ||
          key === "member_image_zheng" ||
          key === "member_image_fan"
        ) {
          if (other_checked) {
            data[key] = newForm[key];
          }
        } else {
          if (newForm[key]) {
            data[key] = newForm[key];
          }
        }
      }
      this.checkout(data);
    },
    uploadClick() {
      this.$router.push("/upload");
      setSession("form", this.form);
      setSession("checkedAll", this.checkedAll);
      setSession("checked1", this.checked1);
      setSession("checked2", this.checked2);
      setSession("other_checked", this.other_checked);
      setSession("areas", this.areas);
    },
    onCode() {
      if (this.codeBool) {
        const { mobile } = this.form;
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!mobile) {
          Toast("请输入手机号");
          return;
        }
        if (!myreg.test(mobile)) {
          Toast("请输入正确的手机号");
          return;
        }
        const params = {
          url: "/account/sendCode",
          dataType: "json",
          data: {
            mobile: mobile
          },
          success: res => {
            Toast("验证发送成功");
            this.timeInterval();
          }
        };
        Ajax(params);
      }
    },
    timeInterval() {
      if (this.times) {
        clearInterval(this.times);
      }
      this.codeBool = false;
      this.buttonText = 60;
      this.times = setInterval(() => {
        this.buttonText -= 1;
        if (this.buttonText < 0) {
          this.buttonText = "获取验证码";
          clearInterval(this.times);
          this.codeBool = true;
        }
      }, 1000);
    },
    checkout(data) {
      const { mobile, code } = this.form;
      if (mobile && code) {
        const params = {
          url: "/intransit/checkout",
          dataType: "json",
          data: {
            mobile: mobile,
            code: code
          },
          success: res => {
            this.addCounsel(data);
          }
        };
        Ajax(params);
      }
    },
    addCounsel(data) {
      const params = {
        url: "/member/addMember",
        dataType: "json",
        data: data,
        success: res => {
          Toast("已成功提交");
          setSession("form", "");
          setSession("checkedAll", "");
          setSession("checked1", "");
          setSession("checked2", "");
          setSession("other_checked", "");
          setSession("areas", "");
          setSession("url1", "");
          setSession("url2", "");
          this.$router.push({
            name: "suc"
          });
        }
      };
      Ajax(params);
    },
    interestClick() {
      setSession("form", this.form);
      setSession("checkedAll", this.checkedAll);
      setSession("checked1", this.checked1);
      setSession("checked2", this.checked2);
      setSession("other_checked", this.other_checked);
      setSession("areas", this.areas);
      this.$router.push({
        name: "interest",
        query: {
          url: `${ossBaseUrl}/policy/%E4%BC%9A%E5%91%98%E7%89%B9%E6%9D%83%E9%A1%B5%E9%9D%A2.jpg`
        }
      });
    },
    yinshi() {
      setSession("form", this.form);
      setSession("checkedAll", this.checkedAll);
      setSession("checked1", this.checked1);
      setSession("checked2", this.checked2);
      setSession("other_checked", this.other_checked);
      setSession("areas", this.areas);
      // this.$router.push({
      //   name: "interest",
      //   query:{url:`${ossBaseUrl}/policy/%E9%9A%90%E7%A7%81%E6%9D%A1%E6%AC%BE.jpg`}
      // });
      window.open("/privacy/");
    },
    tiaokuan() {
      setSession("form", this.form);
      setSession("checkedAll", this.checkedAll);
      setSession("checked1", this.checked1);
      setSession("checked2", this.checked2);
      setSession("other_checked", this.other_checked);
      setSession("areas", this.areas);
      this.$router.push({
        name: "interest",
        query: {
          url: `${ossBaseUrl}/policy/%E5%9C%B0%E4%B8%AD%E6%B5%B7%E8%88%AA%E6%B5%B7%E5%AE%B6%E4%BF%B1%E4%B9%90%E9%83%A8%E6%9D%A1%E6%AC%BE.jpg`
        }
      });
    },
    mscPC() {
      setSession("form", this.form);
      setSession("checkedAll", this.checkedAll);
      setSession("checked1", this.checked1);
      setSession("checked2", this.checked2);
      setSession("other_checked", this.other_checked);
      setSession("areas", this.areas);
    },
    checkedClick(val) {
      let { checked1, checked2 } = this;
      if (val == 1) {
        // this.checked1 = !checked1;
        if (this.checked1 && checked2) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
      }
      if (val == 2) {
        // this.checked2 = !checked2;
        if (checked1 && this.checked2) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
      }
    },
    checkedAllClick() {
      let { checkedAll } = this;
      if (!checkedAll) {
        this.checked1 = false;
        this.checked2 = false;
      } else {
        this.checked1 = true;
        this.checked2 = true;
      }

      // this.checkedAll = !checkedAll;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/index.vue